import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentHYCSDocumentVerificationData,
  type EnrollmentHYCSDocumentVerificationSubmitOutput,
} from '../../../../models'
import { DocumentVerificationStatus } from '../../../../models/enrollment/enrollment'

export const getEnrollmentHYCSDocumentVerificationDataMock: EnrollmentHYCSDocumentVerificationData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/document-verification',
  enrollmentData: {
    applicationId: '123',
  },
}

export const submitEnrollmentHYCSDocumentVerificationDataMock: EnrollmentHYCSDocumentVerificationSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  enrollmentData: {
    applicationId: '123',
    documentVerificationStatus: 'PENDING',
    documentVerificationUrl: 'https://example.com',
  },
}

let callCount = 0

export const submitEnrollmentHYCSDocVerificationCheckStatusDataMock = () => {
  callCount++

  return {
    __typename: 'SubmitEnrollmentSuccess',
    path: '/enrollment/hycs/document-verification-complete',
    documentVerificationStatus:
      callCount >= 3 ? DocumentVerificationStatus.Complete : DocumentVerificationStatus.Pending,
    documentVerificationUrl: 'https://example.com',
  }
}

export const mockGetEnrollmentHYCSDocumentVerificationData = graphql.mutation(
  'getEnrollmentHYCSDocumentVerificationData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSDocumentVerificationDataMock } })
  },
)

export const mockSubmitEnrollmentHYCSDocumentVerificationData = graphql.mutation(
  'submitEnrollmentHYCSDocumentVerificationData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSDocumentVerificationDataMock } })
  },
)

export const mockSubmitEnrollmentHYCSDocVerificationCheckStatusData = graphql.mutation(
  'submitEnrollmentHYCSDocVerificationCheckStatusData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSDocVerificationCheckStatusDataMock() } })
  },
)

export const mockEnrollmentHYCSDocumentVerification = [
  mockSubmitEnrollmentHYCSDocVerificationCheckStatusData,
  mockGetEnrollmentHYCSDocumentVerificationData,
  mockSubmitEnrollmentHYCSDocumentVerificationData,
]
